/* VZ UX BOOST — preview theme 193684111652 */
(function(){
  var d=document,w=window,root=d.documentElement;
  var top=d.getElementById('vzx-top'),chip=d.getElementById('vzx-igchip');

  /* lift floating buttons above the sticky add-to-cart bar when it is on screen */
  function lift(){
    var bar=d.querySelector('sticky-add-to-cart .sticky-add-to-cart__bar'),h=0;
    if(bar){var r=bar.getBoundingClientRect(),cs=getComputedStyle(bar);
      if(r.height>0&&r.top<w.innerHeight-4&&cs.visibility!=='hidden'&&+cs.opacity>0.05)h=Math.max(0,w.innerHeight-r.top);}
    root.style.setProperty('--vzx-lift',h+'px');
  }
  /* back to top */
  if(top){top.hidden=false;
    var onS=function(){top.classList.toggle('is-on',w.scrollY>600);lift();};
    w.addEventListener('scroll',onS,{passive:true});w.addEventListener('resize',onS);onS();setTimeout(lift,1200);
    top.addEventListener('click',function(e){e.preventDefault();
      w.scrollTo({top:0,behavior:w.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      var m=d.getElementById('MainContent');if(m){m.setAttribute('tabindex','-1');setTimeout(function(){m.focus({preventScroll:true})},500);}});
  }

  /* popup: 12s delay, 55% scroll, or desktop exit-intent; once per session; never after subscribe */
  var pop=d.getElementById('vzx-pop');
  if(pop){
    var SS=w.sessionStorage,LS=w.localStorage,shown=false,lastFocus=null;
    var stepF=pop.querySelector('[data-step=form]'),stepOk=pop.querySelector('[data-step=ok]');
    function open(force){
      if(!force&&(shown||SS.getItem('vzx-pop-seen')||LS.getItem('vzx-subscribed')))return;
      /* don't stack on top of another open modal (cart drawer, search, Shopify Forms) */
      if(!force&&d.querySelector('dialog[open], .vzx-pop:not([hidden]), details.menu-drawer-container[open]'))return; /* T2: never over an open phone menu */
      shown=true;SS.setItem('vzx-pop-seen','1');lastFocus=d.activeElement;
      pop.hidden=false;d.body.classList.add('vzx-lock');
      setTimeout(function(){var f=pop.querySelector(stepOk.hidden?'input[type=email]':'.vzx-pop__code');f&&f.focus({preventScroll:true});},60);
    }
    function close(){pop.hidden=true;d.body.classList.remove('vzx-lock');SS.setItem('vzx-pop-seen','1');lastFocus&&lastFocus.focus&&lastFocus.focus({preventScroll:true});}
    w.vzxOpenTransmission=function(){open(true)};
    pop.addEventListener('click',function(e){if(e.target.closest('[data-vzx-close]'))close();
      var c=e.target.closest('[data-vzx-copy]');if(c){var code=c.getAttribute('data-vzx-copy');(navigator.clipboard?navigator.clipboard.writeText(code):Promise.reject()).catch(function(){}).then(function(){var s=c.querySelector('span');if(s)s.textContent='COPIED';});}});
    d.addEventListener('keydown',function(e){if(!pop.hidden&&e.key==='Escape')close();
      if(!pop.hidden&&e.key==='Tab'){var f=[].slice.call(pop.querySelectorAll('button:not([hidden]),input,a[href]')).filter(function(x){return x.offsetParent});if(!f.length)return;var a=f[0],z=f[f.length-1];
        if(e.shiftKey&&d.activeElement===a){e.preventDefault();z.focus()}else if(!e.shiftKey&&d.activeElement===z){e.preventDefault();a.focus()}}});
    d.addEventListener('click',function(e){var a=e.target.closest('[data-vzx-open]');if(a){e.preventDefault();open(true);}});
    var form=pop.querySelector('form');if(form)form.addEventListener('submit',function(){SS.setItem('vzx-pop-sent','1');});
    var posted=/[?&]customer_posted=true/.test(location.search);
    if(posted&&SS.getItem('vzx-pop-sent')){SS.removeItem('vzx-pop-sent');LS.setItem('vzx-subscribed','1');stepF.hidden=true;stepOk.hidden=false;open(true);}
    else if(pop.querySelector('[data-vzx-err]')&&SS.getItem('vzx-pop-sent')){SS.removeItem('vzx-pop-sent');open(true);}
    else {
      var t=setTimeout(function(){open(false)},12000);
      var onScroll=function(){var h=root.scrollHeight-w.innerHeight;if(h>0&&w.scrollY/h>0.55){open(false);w.removeEventListener('scroll',onScroll);}};
      w.addEventListener('scroll',onScroll,{passive:true});
      if(w.matchMedia('(hover: hover) and (pointer: fine)').matches)d.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<8)open(false);});
      if(/[?&]vzx_pop=1/.test(location.search))open(true); /* preview helper */
    }
  }

  /* PDP: trust row after the accelerated checkout */
  var tpl=d.getElementById('vzx-trust-tpl');
  function trust(){var host=d.querySelector('.product-details .product-form-buttons, .product-form-buttons');if(!tpl||!host||host.querySelector('.vzx-trust'))return;host.appendChild(tpl.content.cloneNode(true));}
  if(tpl){trust();var tq=0;new MutationObserver(function(){if(tq)return;tq=1;requestAnimationFrame(function(){tq=0;trust();});}).observe(d.body,{childList:true,subtree:true});} /* speed v1: batched to once per frame */

  /* recently decoded (localStorage, this device only) */
  var K='vzx-rv',list=[];try{list=JSON.parse(localStorage.getItem(K)||'[]')}catch(e){}
  var cur=d.getElementById('vzx-rv-cur'),me=null;
  if(cur){try{me=JSON.parse(cur.textContent)}catch(e){}}
  var sec=d.getElementById('vzx-rv');
  if(sec){var show=list.filter(function(p){return !me||p.h!==me.h}).slice(0,8);
    if(show.length){var row=sec.querySelector('.vzx-rv__row');
      show.forEach(function(p){var a=d.createElement('a');a.className='vzx-rv__card';a.href=p.u;a.setAttribute('role','listitem');
        var im=d.createElement('img');im.alt=p.t;if(p.i)im.src=p.i;var b=d.createElement('b');b.textContent=p.t;var s=d.createElement('span');s.textContent=p.p;
        a.appendChild(im);a.appendChild(b);a.appendChild(s);row.appendChild(a);});
      var ft=d.querySelector('body > footer');if(ft&&ft.parentNode)ft.parentNode.insertBefore(sec,ft);sec.hidden=false;}}
  if(me){list=list.filter(function(p){return p.h!==me.h});list.unshift(me);try{localStorage.setItem(K,JSON.stringify(list.slice(0,12)))}catch(e){}}
})();